import {
  AutoColumn,
  Button,
  RowBetween,
  Text,
  AutoRow,
  Box,
  NumericalInput,
  ConfirmationModalContent,
  useModal,
  Message,
  MessageText,
  PreTitle,
  DynamicSection,
  Flex,
  Toggle,
} from '@pancakeswap/uikit'
import styled from 'styled-components'
import { useTranslation } from '@pancakeswap/localization'

const StyledInput = styled(NumericalInput)`
  background-color: ${({ theme }) => theme.colors.input};
  box-shadow: ${({ theme, error }) => theme.shadows[error ? 'warning' : 'inset']};
  border-radius: 16px;
  padding: 8px 16px;
  font-size: 16px;
  width: 100%;
  margin-bottom: 16px;
`

const NoLiquidityMessage = ({
  startPriceTypedValue,
  onStartPriceInput,
  baseCurrency,
  invertPrice,
  price,
  quoteCurrency,
}) => {
  const {
    t,
    currentLanguage: { locale },
  } = useTranslation()
  return (
    <Box>
      <PreTitle mb="8px">{t('Set Starting Price')}</PreTitle>
      <Message variant="warning" mb="8px">
        <MessageText>
          {t(
            'This pool must be initialized before you can add liquidity. To initialize, select a starting price for the pool. Then, enter your liquidity price range and deposit amount. Gas fees will be higher than usual due to the initialization transaction.',
          )}
          <br />
          <br />

          <b>{t('Fee-on transfer tokens and rebasing tokens are NOT compatible with V3.')}</b>
        </MessageText>
      </Message>
      <StyledInput className="start-price-input" value={startPriceTypedValue} onUserInput={onStartPriceInput} />
      <AutoRow justifyContent="space-between" mb="24px">
        <Text>{t('Current %symbol% Price', { symbol: baseCurrency?.symbol })}:</Text>
        <Text>
          {price ? (invertPrice ? price?.invert()?.toSignificant(5) : price?.toSignificant(5)) : '-'}
          <span style={{ marginLeft: '4px' }}>{quoteCurrency?.symbol}</span>
        </Text>
      </AutoRow>
    </Box>
  )
}

export default NoLiquidityMessage
